var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"title-cont"}},[_vm._m(0),_c('div',[_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('div',{staticStyle:{"z-index":"1","position":"absolute","top":"0","height":"100%"}},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-cont"},[_c('div',{staticClass:"back-crcl"})])
}]

export { render, staticRenderFns }